import createClient from 'openapi-fetch'
import { getMiddleware } from './utils'
import type { paths } from '../types/integrations/party/operations'

const partyClient = createClient<paths>({
  baseUrl: 'http://flow-process/api',
})
partyClient.use(getMiddleware())

// export async function getPartyByExternalId(externalId: string, roles: FLOW_ROLES) {
//   const flowProcess = createFlowClient(roles)
//   return await flowProcess.get(`/parties/${externalId}`)
// }

export async function getPartyByExternalId(externalId: string, headers: Record<string, string>) {
  return await partyClient.GET('/parties/{partyId}', {
    params: {
      path: { partyId: externalId },
    },
    headers,
  })
}

export function getPartiesByFlowId(processId: string, headers: Record<string, string>) {
  return partyClient.GET('/parties/processId/{processId}', {
    params: {
      path: { processId },
    },
    headers,
  })
}
